import actions from '@/store/modules/finances/deep-cloud-connect/actions';
import mutations from '@/store/modules/finances/deep-cloud-connect/mutations';
import initialState from '@/store/modules/finances/deep-cloud-connect/state';

export default {
  namespaced: true,
  state: { ...initialState },
  mutations,
  actions,
};
